var styles = {"setupFee":"ep-pricing-module-setup-fee-c2V0d"};

export { styles as default };
//# sourceMappingURL=ep-pricing-esm-components-setup-fee-setup-fee.module.scss.js.map
